import React from 'react'
import Icon, { IconKey } from 'components/ui/icon'
import styles from './index.module.css'

export type Props = {
  iconType?: IconKey
  header?: React.ReactNode
  message?: string
  children?: React.ReactNode
}

const ContactsMessage = (props: Props): React.ReactElement<'div'> => {
  const { iconType, header, message, children } = props
  return (
    <div className={styles.contactsMessageBlock}>
      <div className={styles.contactsMessageBlockIcon}>
        {iconType ? (
          <Icon type={iconType} color="#5f63ee" width="1.8em" height="1.8em" />
        ) : null}
      </div>
      <div className={styles.contactsMessageBlockHeader}>{header}</div>
      <div className={styles.contactsMessageBlockMessage}>{message}</div>
      <div className={styles.contactsMessageBlockContent}>{children}</div>
    </div>
  )
}

export default ContactsMessage
